import React from 'react';

const Loading = () => {
    return (
        <div className="flex items-center justify-center h-screen">
            <div className="w-20 h-20 border-8 border-solid rounded-full animate-spin 
                      border-t-pink-500 border-r-yellow-400 border-b-green-400 border-l-blue-500">
            </div>
        </div>
    );
};

export default Loading;
